var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    [
      _c("div", { staticClass: "row no-gutters" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c("table-data", {
              attrs: {
                route: _vm.url.getList,
                settings: _vm.table.settings,
                columns: _vm.table.columns,
                inlineFilters: _vm.table.filters,
                autoUpdateFilter: _vm.table.autoUpdateFilter,
                addParamsToUrl: _vm.table.addParamsToUrl,
                loadingMsg: _vm.table.loadingMsg,
                notFoundMsg: _vm.table.notFoundMsg,
                orderByTemplate: _vm.table.orderByTemplate,
                tableClass: "table-responsive-sm",
              },
              on: { "error-load": _vm.showError },
              scopedSlots: _vm._u([
                {
                  key: "filters",
                  fn: function ({ tableFilters, search }) {
                    return [
                      _c(
                        "form",
                        {
                          attrs: { autocomplete: "false" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return search.apply(null, arguments)
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return search.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "row header" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("header-list", {
                                  attrs: {
                                    title: _vm.pageTitle,
                                    placeholderSearch: _vm.searchPlaceholder,
                                    routeAddName: `${_vm.moduleCode}.${_vm.pageID}.create`,
                                    canAdd: _vm.canAdd,
                                    addTitle: _vm.addTitle,
                                  },
                                  model: {
                                    value: tableFilters.q,
                                    callback: function ($$v) {
                                      _vm.$set(tableFilters, "q", $$v)
                                    },
                                    expression: "tableFilters.q",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "body",
                  fn: function ({ row, index, remove }) {
                    return [
                      _c("td", { class: _vm.table.columns[0].class }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(row.title) +
                            "\n                        "
                        ),
                        _c("span", { staticClass: "ml-1 badge badge-info" }, [
                          _vm._v(_vm._s(row.layers_count)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", { class: _vm.table.columns[1].class }, [
                        _c(
                          "a",
                          { attrs: { href: row.url, target: "_blank" } },
                          [_vm._v(_vm._s(row.url))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { class: _vm.table.columns[2].class }, [
                        _vm._v(_vm._s(row.service.description)),
                      ]),
                      _vm._v(" "),
                      _vm.checkActions
                        ? _c(
                            "column-actions",
                            {
                              attrs: {
                                routeEdit: `${_vm.moduleCode}.${_vm.pageID}.show`,
                                canDetail: _vm.canDetail,
                                canEdit: _vm.canEdit,
                                canDelete: _vm.canDelete,
                                row: row,
                                index: index,
                                callbackDelete: remove,
                              },
                              on: { delete: _vm.deleteItem },
                            },
                            [
                              _vm.canView
                                ? _c(
                                    "li",
                                    { staticClass: "list-group-item" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: `${_vm.moduleCode}.${_vm.pageID}.view`,
                                              params: { id: row.id },
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-list action view",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canEdit
                                ? _c("li", { staticClass: "list-group-item" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.confirm(
                                              _vm.reloadItem,
                                              row.id,
                                              `Pretende efetuar o reload do serviço <strong>${row.title}</strong> ?`
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-sync-alt action reload",
                                        }),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("modal-confirmation", {
        ref: "modalConfirmation",
        attrs: {
          title: "Remover Serviço",
          text: "Deseja remover o serviço selecionado?",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }